import { create } from 'zustand';
import { RenderLogDoc } from 'pdftron/debug/renderLogConstants';

export type RenderLogDocFilter = 'ALL' | RenderLogDoc;

interface RenderLogStore {
  collapsed: boolean;
  paused: boolean;
  docFilter: RenderLogDocFilter;
  setCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
  setPaused: (paused: boolean) => void;
  togglePaused: () => void;
  setDocFilter: (docFilter: RenderLogDocFilter) => void;
}

export const useRenderLogStore = create<RenderLogStore>((set, get) => ({
  collapsed: true,
  paused: false,
  docFilter: 'ALL',

  setCollapsed: (collapsed) => set({ collapsed }),
  toggleCollapsed: () => set({ collapsed: !get().collapsed }),

  setPaused: (paused) => set({ paused }),
  togglePaused: () => set({ paused: !get().paused }),

  setDocFilter: (docFilter) => set({ docFilter }),
}));
